import { render, staticRenderFns } from "./FragmentsEditor.vue?vue&type=template&id=5e0577f0&scoped=true&"
import script from "./FragmentsEditor.vue?vue&type=script&lang=js&"
export * from "./FragmentsEditor.vue?vue&type=script&lang=js&"
import style0 from "./FragmentsEditor.vue?vue&type=style&index=0&id=5e0577f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0577f0",
  null
  
)

export default component.exports